(ns frontend.view.entity-viewers.modules.entity-esign.event
  (:require
    [clojure.set :as set]
    [common.util :as cu]
    [frontend.controller.websocket.event :as ws]
    [frontend.view.entity-viewers.modules.entity-esign.sub :as sub]
    [re-frame.core :as rf]
    [ui.dom-globals :as dg]))

(defn apply-updates-to-entities
  [entity-type old-entities new-entities]
  (let [updates (->> new-entities
                     (cu/filter-by :entity/type entity-type)
                     (doall))
        update-ids (->> updates
                        (map :db/id)
                        (set))
        disabled-ids (->> updates
                          (filter :common/disabled?)
                          (map :db/id)
                          (set))
        result (concat (->> old-entities
                            (remove (fn [templ]
                                      (or (some #{(:db/id templ)} disabled-ids)
                                          (some #{(:db/id templ)} update-ids)))))
                       (->> updates
                            (remove :common/disabled?)))]
    result))

(rf/reg-event-fx
  ::process-updates
  (fn [{db :db} [_ {:keys [entity-id entities]}]]
    (let [updated-signatories (apply-updates-to-entities :entity.type/signatory (get-in db [::sub/signatories entity-id]) entities)
          updated-processes (apply-updates-to-entities :entity.type/esign-process (get-in db [::sub/esign-processes entity-id]) entities)
          updated-attachments (apply-updates-to-entities :entity.type/attachment (get-in db [::sub/attachments entity-id]) entities)]
      {:db (-> db
               (assoc-in [::sub/signatories entity-id] updated-signatories)
               (assoc-in [::sub/esign-processes entity-id] updated-processes)
               (assoc-in [::sub/attachments entity-id] updated-attachments))})))


(rf/reg-event-fx
  ::cleanup
  (fn [{db :db} [_ entity-id]]
    {:db (-> db
             (assoc-in [::sub/signatories entity-id] nil)
             (assoc-in [::sub/esign-processes entity-id] nil)
             (assoc-in [::sub/attachments entity-id] nil))}))

(rf/reg-event-fx
  ::esign-process-canceled
  (fn [{_db :db} [_]]
    {}))

(rf/reg-event-fx
  ::cancel-esign-process-failed
  (fn [{_db :db} [_]]
    (js/console.log "Canceling esign process failed")
    {}))

(rf/reg-event-fx
  ::cancel-esign-process
  (fn [{:keys [_db]} [_ esign-process-id]]
    {::ws/send {:id         :esign/cancel
                :body       {:esign-process-id esign-process-id}
                :on-success [::esign-process-canceled]
                :on-error   [::cancel-esign-process-failed]}}))

(rf/reg-event-fx
  ::send-reminder-comment-success
  (fn [{db :db} [_ signatory-id]]
    {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
  ::send-reminder-comment-failed
  (fn [{db :db} [_ signatory-id]]
    (js/console.log "Reminding failed")
    {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
  ::send-reminder-comment
  (fn [{:keys [db]} [_ {:keys [esign-process-id email signatory-id]}]]
    {:db       (update db ::sub/reminding-signatory-ids set/union #{signatory-id})
     ::ws/send {:id         :esign/remind
                :body       {:esign-process-id esign-process-id
                             :signatory-email  email
                             :signatory-id     signatory-id}
                :on-success [::send-reminder-comment-success signatory-id]
                :on-error   [::send-reminder-comment-failed signatory-id]}}))

(rf/reg-event-fx
  ::download-url-success
  (fn [_ [_ resp]]
    (dg/download-file
      (-> resp
          :body
          :download-url))
    {}))

(rf/reg-event-fx
  ::download-failed
  (fn [_ _]
    (js/console.log "Download failed")
    {}))

(rf/reg-event-fx
  ::download-contract
  (fn [_ [_ esign-process-id attachment-id]]
    {::ws/send {:id         :esign/download-contract
                :body       {:esign-process-id esign-process-id
                             :attachment-id    attachment-id}
                :on-success [::download-url-success]
                :on-error   [::download-failed]}}))

;; V2

(rf/reg-event-fx
  ::v2-cancel-esign-process-success
  [rf/trim-v]
  (fn [_cofx [resp]]
    (js/console.log "V2 cancel process success " resp)))

(rf/reg-event-fx
  ::v2-cancel-esign-process-error
  [rf/trim-v]
  (fn [_cofx [resp]]
    (js/console.log "V2 cancel process failed " resp)))

(rf/reg-event-fx
  ::v2-cancel-esign-process
  [rf/trim-v]
  (fn [_ [esign-process-id]]
    {::ws/send {:id         :esign-v2/cancel
                :body       {:esign-process-id esign-process-id}
                :on-success [::v2-cancel-esign-process-success]
                :on-error   [::v2-cancel-esign-process-error]}}))

(rf/reg-event-fx
  ::v2-send-reminder-comment-success
  [rf/trim-v]
  (fn [{db :db} [signatory-id]]
    {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
  ::v2-send-reminder-comment-error
  [rf/trim-v]
  (fn [{db :db} [signatory-id]]
    (js/console.log "V2 send reminder comment error")
    {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
  ::v2-send-reminder-comment
  [rf/trim-v]
  (fn [{:keys [db]} [{:keys [esign-process-id signatory-id]}]]
    {:db       (update db ::sub/reminding-signatory-ids set/union #{signatory-id})
     ::ws/send {:id         :esign-v2/remind
                :body       {:esign-process-id esign-process-id
                             :signatory-id     signatory-id}
                :on-success [::v2-send-reminder-comment-success signatory-id]
                :on-error   [::v2-send-reminder-comment-error signatory-id]}}))

(rf/reg-event-db
  ::get-client-safe-configurations-done
  [rf/trim-v]
  (fn [db [success? resp]]
    (if success?
      (-> db
          (assoc ::sub/configurations-loaded? true)
          (assoc ::sub/configurations (-> resp
                                          :body
                                          :client-safe-configurations)))
      (do
        (js/console.log "Error getting config " resp)
        db))))

(rf/reg-event-fx
  ::get-client-safe-configurations
  (fn [_]
    {::ws/send {:id         :esign/get-client-safe-configurations
                :on-success [::get-client-safe-configurations-done true]
                :on-error   [::get-client-safe-configurations-done false]}}))
